import React, { useState, useEffect } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

export const ActiveWardrobeContext = React.createContext();

const lsActiveWardrobe = reactLocalStorage.get('activeWardrobe', 0);

export const ActiveWardrobeProvider = ({ children }) => {
  const [activeWardrobe, setActiveWardrobe] = useState(lsActiveWardrobe);

  useEffect(() => {
    reactLocalStorage.set('activeWardrobe', parseInt(activeWardrobe));
  }, [activeWardrobe]);

  return (
    <ActiveWardrobeContext.Provider value={{ activeWardrobe, setActiveWardrobe }}>
      {children}
    </ActiveWardrobeContext.Provider>
  );
};
